import { render, staticRenderFns } from "./App.vue?vue&type=template&id=25ff6e38&"
import script from "./App.vue.ts?vue&type=script&lang=ts&"
export * from "./App.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports